import { HistoryPresenter } from '@/presentation/presenters/history/historyPresenter'
import { HistoryListViewModel } from '@/presentation/viewmodels/history/historyListViewModel'
import { HistoryPageStateViewModel } from '@/presentation/viewmodels/history/historyPageStateViewModel'
import { HistorySourceCodeViewModel } from '@/presentation/viewmodels/history/historySourceCodeViewModel'

export function useHistoryPresenter(
  presenter: HistoryPresenter = new HistoryPresenter(
    new HistoryPageStateViewModel(),
    new HistoryListViewModel(),
    new HistorySourceCodeViewModel()
  )
) {
  return {
    initState: presenter.initState.bind(presenter),
    addHistoryList: presenter.addHistoryList.bind(presenter),
    clickSummary: presenter.clickSummary.bind(presenter)
  }
}
